import { combineReducers } from "redux";
import loginReducer from "./login.slices";
import {
  manualDataReducer,
  initialDashDataReducer,
  refreshDataReducer,
  requestDataReducer,
  reportAnswerReducer,
  postLogReducer,
  switchSiteReducer,
  frameWorkSliceReducer,
  dbimsDataSliceReducer,
  loginDataReducer,
  parichayUrlDataReducer,
  postManualDataReducer,
  overAllDataReducer,
  getDBIMDataReducer,
  parichayLogoutReducer,
  parichayAuthenticationReducer,
  checkUserAuthenticityReducer,
  fetchDbimSurveyQuestionsReducer,
  postDbimSurveyReducer,
  checkLiveReportStatusReducer,
  fetchdbimoverAllData,
  logoutUserReducer,
  checkParichayAuth,
  excelReportDataReducer,
  checkSiteStatus,
  advancedExcelReportReducer,
} from "./dashData.slices";

export const appReducer = (state, action) => {
  return combineReducers({
    login: loginReducer,
    manualData: manualDataReducer,
    initialDashData: initialDashDataReducer,
    refreshApi: refreshDataReducer,
    requestApi: requestDataReducer,
    reportAnswerData: reportAnswerReducer,
    postLogData: postLogReducer,
    switchSiteData: switchSiteReducer,
    frameWorkData: frameWorkSliceReducer,
    dbimsQuestionData: dbimsDataSliceReducer,
    loggedinData: loginDataReducer,
    parichayUrl: parichayUrlDataReducer,
    postManualData: postManualDataReducer,
    fetchOverAllData: overAllDataReducer,
    fetchManualDbim: getDBIMDataReducer,
    parichayLogout: parichayLogoutReducer,
    parichayCheckToken: parichayAuthenticationReducer,
    checkAuthentication: checkUserAuthenticityReducer,
    getDbimSurveyQues: fetchDbimSurveyQuestionsReducer,
    addDbimSurvey: postDbimSurveyReducer,
    liveReportStatus: checkLiveReportStatusReducer,
    getDBIMOverallData: fetchdbimoverAllData,
    logoutData: logoutUserReducer,
    getParichayAuth: checkParichayAuth,
    getExcelReport: excelReportDataReducer,
    getAdvanceExcelReport: advancedExcelReportReducer,
    siteStatus: checkSiteStatus,
  })(state, action);
};

export const rootReducer = (state, action) => {
  if (action?.type === "RESET") {
    // Reset the entire state
    state = undefined;
  }
  return appReducer(state, action);
};
